'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresDiscountCode]');

var WinresDiscountCodeController = function () {
    function WinresDiscountCodeController($scope, userService, discountService, cancelService) {
        _classCallCheck(this, WinresDiscountCodeController);

        this.$scope = $scope;
        this.userService = userService;
        this.discountService = discountService;
        this.cancelService = cancelService;
    }

    _createClass(WinresDiscountCodeController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.enabled = false;
            this.$scope.$watch(function () {
                return _this.userService.getCurrentUser();
            }, function (user) {
                if (user) {
                    // Discount field visiblity from Winres.
                    var discountInUse = user.getParameter('DiscountInUse') === 'TRUE';

                    _this.enabled = discountInUse;

                    if (_this.enabled) {
                        log("Discounts are in use.");
                    } else {
                        log("Discounts are not in use.");
                    }

                    // Pre-fill the field if in use.
                    _this.code = _this.discountService.getDiscountCodeFromLocalStorage();
                }
            });
        }
    }, {
        key: 'use',
        value: function use() {
            var _this2 = this;

            if (this.pending) {
                this.cancelService.cancel(this.promise);
                this.promise = null;
                log('Canceled previous promise.');
            }

            this.pending = true;

            var data = this.context.getContext();

            var request = this.discountService.useDiscountCode(this.code, data.Products, data.Passengers);

            this.promise = request.then(function (discounts) {
                if (discounts == null) {
                    // Canceled.
                    return;
                }

                // Clear exising discount products.
                _this2.discountService.clearDiscountProductsFromCart(_this2.context);

                log('Discounts with code ' + _this2.code + ':', discounts);

                var hasDiscounts = discounts.length > 0;
                if (!hasDiscounts) {
                    throw new Error('No discounts available with code ' + _this2.code + '.');
                }

                // Found discounts, add them to shopping cart.

                _.each(discounts, function (d) {
                    _this2.discountService.addDiscountProductToCart(_this2.context, _this2.code, d.Price, d.DestCode, d.ProdCode, d.BeginDate, d.EndDate, d.Name, d.Scope);
                });

                // Update discount products for context.
                _this2.discountService.createDiscountProducts(_this2.context);

                // Prebook discount code.
                data.DiscountCode = _this2.code;
            }).catch(function (error) {
                // Don't do this - maybe there was just a small typo
                // and the user wants to fix it.
                // // Empty discount code field.
                // this.code = '';

                // Empty prebook discount code.        
                data.DiscountCode = '';

                throw error;
            }).finally(function () {
                _this2.pending = false;
                // this.promise = null; // We want to be able to show the result
            });
        }
    }]);

    return WinresDiscountCodeController;
}();

WinresDiscountCodeController.$inject = ['$scope', 'userService', 'discountService', 'cancelService'];

_module3.default.component('winresDiscountCode', {
    template: require('./winresDiscountCode.html'),
    controller: WinresDiscountCodeController,
    bindings: {
        context: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDiscountCode/winresDiscountCode.js
// module id = 522
// module chunks = 2